import { z } from 'zod';

export const dashboardSearchSchema = z.object({
    openSheet: z.literal('sessions/today').optional(),
    checkout_session_id: z.string().optional(),
    // Set by the account app's /verify-email page once it has consumed the confirmation token.
    // Only the success outcome lands here; the rest go to Settings/Profile.
    emailVerification: z.literal('verified').optional(),
});

export type DashboardSearch = z.infer<typeof dashboardSearchSchema>;
